import { html } from 'lit';
import type { TemplateResult } from 'lit';
import type { ModelDef } from '@/state/models';
import { chevronDownIcon } from './icons';

export function renderModelPicker(
  options: ModelDef[],
  currentId: string,
  onChange: (id: string) => void,
): TemplateResult {
  return html`
    <div>
      <p class="model-label">Model:</p>
      <div class="model-select-wrap">
        <select
          class="model-select"
          aria-label="Stem separation model"
          @change=${(e: Event) => {
            const target = e.target as HTMLSelectElement;
            onChange(target.value);
          }}
        >
          ${options.map(
            (m) => html`<option value=${m.id} ?selected=${m.id === currentId}>${m.label}</option>`,
          )}
        </select>
        ${chevronDownIcon}
      </div>
    </div>
  `;
}
